import { Error, ErrorProps } from 'ui-components/common/Error';

export const EmptyList = (props: ErrorProps) => <Error {...props} />;
